export const REDIRECT_ON_LOGIN = "MON_redirect_on_login";